/**
 * Resolve a readable name from a Users lookup result.
 *
 * `useFirestoreUser` returns an array of matching Users docs (or "" before the
 * first snapshot), so callers get one place to turn that into a label.
 *
 * @param {Array<{UserName?: string, Email?: string}>} users
 * @returns {string} The user name, the email as fallback, or an empty string.
 */
const getUserDisplayName = (users) => {
    const list = Array.isArray(users) ? users : [];
    const user = list[0];

    if (!user) return '';

    return user.UserName || user.Email || '';
};

export default getUserDisplayName;
